// 51视频 首页 Mock 数据

export const comments = [
  {
    id: 1,
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20headshot%20with%20warm%20lighting%20on%20simple%20neutral%20light%20gray%20background%2C%20casual%20style%2C%20friendly%20expression%2C%20professional%20headshot%20photography&width=80&height=80&seq=avatar-cmt-01&orientation=squarish",
    name: "影视发烧友阿杰",
    time: "2小时前",
    content: "找了好久的蓝莓视频资源终于在这里看到了，4K画质真的没话说，播放一点不卡，比那些广告满天飞的站强太多了，已经推荐给朋友了！",
    likes: 328,
  },
  {
    id: 2,
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20headshot%20with%20soft%20natural%20lighting%20on%20simple%20cream%20background%2C%20modern%20casual%20style%2C%20warm%20genuine%20smile%2C%20clean%20headshot%20photography&width=80&height=80&seq=avatar-cmt-02&orientation=squarish",
    name: "追剧小能手琳琳",
    time: "5小时前",
    content: "糖心视频的片源太全了，更新速度也快，每天晚上睡前必刷。最重要的是完全没有广告，体验感拉满，已经用了快半年了。",
    likes: 256,
  },
  {
    id: 3,
    avatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20Asian%20man%20portrait%20headshot%20with%20warm%20studio%20lighting%20on%20simple%20beige%20background%2C%20smart%20casual%20style%2C%20confident%20smile%2C%20professional%20headshot%20photography&width=80&height=80&seq=avatar-cmt-03&orientation=squarish",
    name: "老张爱看电影",
    time: "1天前",
    content: "黑桃视频专区做得很有特色，分类清晰找片方便。蓝光画质配合家里的投影仪，周末宅家看电影简直不要太爽。",
    likes: 189,
  },
  {
    id: 4,
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20headshot%20with%20bright%20natural%20lighting%20on%20simple%20white%20background%2C%20trendy%20casual%20style%2C%20cheerful%20expression%2C%20clean%20headshot%20photography&width=80&height=80&seq=avatar-cmt-04&orientation=squarish",
    name: "小鹿爱追番",
    time: "1天前",
    content: "妖精视频的番剧更新速度绝了，日更同步追番无压力。画质清晰不说，加载速度还快，地铁上看也不缓冲，通勤必备。",
    likes: 412,
  },
  {
    id: 5,
    avatar: "https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20portrait%20headshot%20with%20warm%20studio%20lighting%20on%20simple%20gray%20background%2C%20business%20casual%20style%2C%20satisfied%20expression%2C%20professional%20headshot%20photography&width=80&height=80&seq=avatar-cmt-05&orientation=squarish",
    name: "周末影评人老王",
    time: "2天前",
    content: "作为一个重度影视爱好者，51视频是我用过最舒服的平台。资源覆盖面广，从经典老片到最新热映都有，关键是无广告不缓冲，良心推荐。",
    likes: 567,
  },
];

export const mediaItems = [
  {
    id: 1,
    title: "蓝莓视频 · 精选影院",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20warm%20lighting%2C%20movie%20theater%20atmosphere%20with%20deep%20blues%20and%20golden%20accents%2C%20film%20strip%20texture%20overlay%2C%20premium%20cinema%20aesthetic%2C%20dark%20ambient%20background%20with%20soft%20glow&width=640&height=360&seq=media-cover-01&orientation=landscape",
    tag: "蓝光4K",
    views: "128.6万",
    rating: "9.2",
  },
  {
    id: 2,
    title: "糖心视频 · 热播剧集",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20scene%20at%20night%20with%20large%20TV%20screen%20displaying%20vibrant%20colors%2C%20soft%20ambient%20lighting%2C%20comfortable%20atmosphere%2C%20home%20theater%20vibe%2C%20cozy%20evening%20entertainment%20mood&width=640&height=360&seq=media-cover-02&orientation=landscape",
    tag: "4K超清",
    views: "96.3万",
    rating: "9.0",
  },
  {
    id: 3,
    title: "黑桃视频 · 经典回顾",
    cover: "https://readdy.ai/api/search-image?query=Vintage%20cinema%20aesthetic%20with%20classic%20film%20projector%20and%20warm%20nostalgic%20golden%20light%2C%20old%20Hollywood%20glamour%20atmosphere%2C%20rich%20textures%20and%20deep%20shadows%2C%20timeless%20movie%20magic%2C%20elegant%20dark%20backdrop&width=640&height=360&seq=media-cover-03&orientation=landscape",
    tag: "高清修复",
    views: "85.7万",
    rating: "9.4",
  },
  {
    id: 4,
    title: "妖精视频 · 热门番剧",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20visual%20with%20colorful%20abstract%20waves%20and%20dynamic%20energy%2C%20modern%20Japanese%20pop%20culture%20aesthetic%2C%20bright%20neon%20accents%20on%20dark%20background%2C%20exciting%20entertainment%20mood%2C%20playful%20and%20energetic%20atmosphere&width=640&height=360&seq=media-cover-04&orientation=landscape",
    tag: "同步更新",
    views: "156.2万",
    rating: "9.3",
  },
  {
    id: 5,
    title: "51视频 · 独家专题",
    cover: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20theater%20setup%20with%20large%20screen%20displaying%20abstract%20colorful%20visuals%2C%20ambient%20warm%20lighting%2C%20premium%20entertainment%20space%2C%20clean%20aesthetic%2C%20contemporary%20interior%20with%20cozy%20atmosphere&width=640&height=360&seq=media-cover-05&orientation=landscape",
    tag: "独家内容",
    views: "72.4万",
    rating: "9.1",
  },
];

export const topics = [
  { id: 1, name: "蓝莓视频", tag: "热播", count: "128.6万", color: "bg-primary-500" },
  { id: 2, name: "4K专区", tag: "推荐", count: "96.3万", color: "bg-accent-500" },
  { id: 3, name: "糖心视频", tag: "新番", count: "85.7万", color: "bg-secondary-500" },
  { id: 4, name: "蓝光原盘", tag: "热门", count: "73.2万", color: "bg-primary-500" },
  { id: 5, name: "黑桃视频", tag: "经典", count: "67.8万", color: "bg-accent-500" },
  { id: 6, name: "妖精视频", tag: "日更", count: "156.2万", color: "bg-secondary-500" },
  { id: 7, name: "无广告观影", tag: "体验", count: "52.4万", color: "bg-primary-500" },
  { id: 8, name: "极速播放", tag: "流畅", count: "48.9万", color: "bg-accent-500" },
  { id: 9, name: "高清修复", tag: "画质", count: "41.3万", color: "bg-secondary-500" },
];

export const carouselItems = [
  {
    id: 1,
    title: "蓝莓视频 · 暑期档强势来袭",
    desc: "多部热门大片蓝光4K同步上线，在家享受影院级观影体验，每周五晚定时更新。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20with%20warm%20golden%20and%20deep%20crimson%20gradient%2C%20abstract%20film%20frame%20elements%20floating%2C%20premium%20movie%20premiere%20atmosphere%2C%20luxurious%20dark%20background%20with%20soft%20spotlight%20effects%2C%20elegant%20entertainment%20visual&width=800&height=400&seq=carousel-01&orientation=landscape",
    tag: "热门推荐",
    badge: "NEW",
  },
  {
    id: 2,
    title: "糖心视频 · 年度口碑剧集合集",
    desc: "豆瓣8.5分以上精选剧集一站式观看，4K修复画质重温经典，每日更新片单。",
    image: "https://readdy.ai/api/search-image?query=Warm%20amber%20and%20deep%20teal%20gradient%20banner%20with%20geometric%20film%20reel%20patterns%2C%20elegant%20award%20ceremony%20vibe%2C%20premium%20quality%20visual%20with%20soft%20bokeh%20lights%2C%20sophisticated%20dark%20backdrop&width=800&height=400&seq=carousel-02&orientation=landscape",
    tag: "口碑精选",
    badge: "HOT",
  },
  {
    id: 3,
    title: "黑桃视频 · 大师经典回顾展",
    desc: "希区柯克、黑泽明等大师作品高清修复版限时上线，影迷不容错过的视觉盛宴。",
    image: "https://readdy.ai/api/search-image?query=Vintage%20classic%20cinema%20banner%20with%20sepia%20and%20warm%20cream%20tones%2C%20old%20film%20camera%20silhouette%2C%20nostalgic%20Hollywood%20golden%20age%20atmosphere%2C%20elegant%20and%20timeless%20visual%20with%20soft%20texture&width=800&height=400&seq=carousel-03&orientation=landscape",
    tag: "限时专题",
    badge: "限时",
  },
  {
    id: 4,
    title: "妖精视频 · 十月新番导视",
    desc: "秋季新番全面上线，独家同步更新。热门续作回归，新番黑马抢先看，追番日历已更新。",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20modern%20anime%20style%20banner%20with%20bright%20magenta%20and%20deep%20purple%20gradient%2C%20dynamic%20action%20lines%20and%20sparkle%20effects%2C%20exciting%20and%20energetic%20visual%20with%20clean%20dark%20background%2C%20pop%20culture%20aesthetic&width=800&height=400&seq=carousel-04&orientation=landscape",
    tag: "新番速递",
    badge: "追番",
  },
  {
    id: 5,
    title: "4K纪录片 · 地球脉动系列",
    desc: "BBC顶级纪录片全系列4K蓝光上线，震撼画面每一帧都是壁纸，自然爱好者必看。",
    image: "https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20style%20banner%20with%20emerald%20green%20and%20deep%20teal%20gradient%2C%20abstract%20mountain%20and%20ocean%20elements%2C%20aerial%20perspective%20feel%2C%20majestic%20and%20serene%20visual%20with%20clean%20composition&width=800&height=400&seq=carousel-05&orientation=landscape",
    tag: "纪录精选",
    badge: "4K",
  },
  {
    id: 6,
    title: "51视频 · 无广告观影体验升级",
    desc: "全站播放器升级完成，加载速度提升40%。蓝光画质不缓冲，给你最纯净的观影体验。",
    image: "https://readdy.ai/api/search-image?query=Modern%20futuristic%20streaming%20platform%20banner%20with%20coral%20red%20and%20warm%20gold%20gradient%2C%20abstract%20data%20flow%20visualization%2C%20high%20tech%20yet%20warm%20atmosphere%2C%20clean%20minimalist%20design%20with%20soft%20glow%20effects&width=800&height=400&seq=carousel-06&orientation=landscape",
    tag: "平台公告",
    badge: "升级",
  },
];

export const indexItems = [
  { id: 1, title: "蓝莓视频专区", desc: "热门大片、院线新片一网打尽", icon: "ri-movie-2-line", count: "2,836部" },
  { id: 2, title: "糖心视频专区", desc: "高分剧集、热播综艺每日更新", icon: "ri-tv-2-line", count: "1,952部" },
  { id: 3, title: "黑桃视频专区", desc: "经典老片、大师作品高清修复", icon: "ri-film-line", count: "3,128部" },
  { id: 4, title: "妖精视频专区", desc: "热门番剧、国漫新番同步追更", icon: "ri-ghost-smile-line", count: "4,507部" },
  { id: 5, title: "4K超清专区", desc: "蓝光原盘画质，极致观影体验", icon: "ri-4k-line", count: "1,246部" },
  { id: 6, title: "纪录片专区", desc: "自然、人文、历史精品纪录", icon: "ri-earth-line", count: "892部" },
  { id: 7, title: "动作冒险专区", desc: "肾上腺素飙升的动作大片", icon: "ri-rocket-2-line", count: "1,573部" },
  { id: 8, title: "悬疑烧脑专区", desc: "反转不断的高分悬疑佳作", icon: "ri-lightbulb-flash-line", count: "968部" },
  { id: 9, title: "喜剧合集专区", desc: "治愈不开心的欢乐剧场", icon: "ri-emotion-laugh-line", count: "1,345部" },
];

export const updates = [
  { id: 1, date: "2026-07-30", title: "播放器全面升级", desc: "全站播放器升级至V3.0版本，加载速度提升40%，蓝光画质更稳定流畅。", tag: "系统" },
  { id: 2, date: "2026-07-28", title: "妖精视频十月新番上线", desc: "秋季新番全面上线，多部热门续作回归，每日同步更新中。", tag: "番剧" },
  { id: 3, date: "2026-07-25", title: "黑桃视频大师经典展", desc: "希区柯克、黑泽明等大师作品高清修复版限时上线。", tag: "专题" },
  { id: 4, date: "2026-07-22", title: "蓝莓视频暑期档更新", desc: "暑期档多部热门大片同步上线蓝光4K版本，每周五定时更新。", tag: "电影" },
  { id: 5, date: "2026-07-20", title: "4K纪录片专区上线", desc: "BBC、国家地理顶级纪录片全系列4K蓝光画质上线。", tag: "纪录" },
  { id: 6, date: "2026-07-18", title: "糖心视频口碑剧集合集", desc: "豆瓣8.5分以上精选剧集一站式观看，片单每日更新中。", tag: "剧集" },
  { id: 7, date: "2026-07-15", title: "移动端适配优化完成", desc: "手机浏览器观看体验全面升级，支持手势控制、画中画播放。", tag: "系统" },
  { id: 8, date: "2026-07-12", title: "无广告观影承诺延续", desc: "51视频延续全年无广告承诺，纯净观影体验得到百万用户认可。", tag: "公告" },
  { id: 9, date: "2026-07-10", title: "社区投稿通道开启", desc: "开放用户投稿通道，优质影评和片单推荐将获得首页展示机会。", tag: "社区" },
];

export const faqItems = [
  {
    id: 1,
    q: "51视频真的完全免费无广告吗？",
    a: "是的，51视频始终坚持完全免费、全程无广告的观影体验。蓝莓视频、糖心视频、黑桃视频、妖精视频四大专区所有内容均免费开放，播放过程中不会插入任何广告，也没有收费会员制度。",
  },
  {
    id: 2,
    q: "蓝光4K画质对网络有要求吗？",
    a: "蓝光4K画质推荐使用10Mbps以上宽带网络以获得最佳体验。不过我们的智能自适应码率技术会根据您的网络状况自动调节画质，即使网络一般也能流畅播放不缓冲。",
  },
  {
    id: 3,
    q: "支持哪些设备观看？",
    a: "51视频支持PC浏览器、手机浏览器、平板等所有主流设备观看。我们针对移动端做了深度适配，支持手势控制音量亮度、画中画播放等功能，随时随地享受高清观影。",
  },
  {
    id: 4,
    q: "内容更新频率是怎样的？",
    a: "蓝莓视频每周五更新热门大片，糖心视频剧集每日更新，黑桃视频经典修复片库持续扩充，妖精视频番剧同步日更。各专区保持高频更新，片库总量已超15,000部。",
  },
  {
    id: 5,
    q: "如何投稿或推荐内容？",
    a: "欢迎通过页面底部的投稿通道提交您的推荐。我们设有专门的审片团队，优质内容将在48小时内完成评估并上线。您的影评和片单推荐也有机会在首页展示。",
  },
];

export const cardItems = [
  {
    id: 1,
    title: "蓝莓视频 · 院线新片速递",
    desc: "每周五同步更新最新院线热门，蓝光4K画质呈现。从动作大片到文艺佳作，你想看的这里都有。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20premiere%20visual%20with%20warm%20spotlight%20and%20red%20carpet%20vibe%2C%20elegant%20movie%20theater%20atmosphere%2C%20premium%20dark%20background%20with%20golden%20light%20accents%2C%20luxurious%20entertainment%20aesthetic&width=600&height=400&seq=card-01&orientation=landscape",
    tag: "热门",
    link: "#media",
  },
  {
    id: 2,
    title: "糖心视频 · 高分剧集推荐",
    desc: "豆瓣8.5+高分剧集全收录，从国产精品到海外佳作，每天都有好剧等你发现。",
    image: "https://readdy.ai/api/search-image?query=Cozy%20evening%20home%20entertainment%20scene%20with%20warm%20amber%20lighting%2C%20comfortable%20sofa%20and%20large%20screen%20glow%2C%20relaxing%20atmosphere%2C%20modern%20living%20room%20with%20soft%20shadows%2C%20intimate%20viewing%20experience&width=600&height=400&seq=card-02&orientation=landscape",
    tag: "精选",
    link: "#media",
  },
  {
    id: 3,
    title: "黑桃视频 · 经典永不褪色",
    desc: "从黑白默片到黄金年代，经典电影高清修复版持续上线。每部都是值得反复品味的佳作。",
    image: "https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20aesthetic%20with%20old%20movie%20poster%20texture%2C%20warm%20sepia%20and%20cream%20tones%2C%20nostalgic%20golden%20age%20Hollywood%20atmosphere%2C%20timeless%20elegant%20visual%20with%20soft%20grain&width=600&height=400&seq=card-03&orientation=landscape",
    tag: "经典",
    link: "#media",
  },
  {
    id: 4,
    title: "妖精视频 · 追番必备指南",
    desc: "十月新番全面上线，热门续作与新番黑马一网打尽。日更同步，追番不等待。",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20modern%20anime%20style%20collage%20with%20colorful%20dynamic%20elements%2C%20energetic%20pop%20culture%20aesthetic%2C%20bright%20accent%20colors%20on%20clean%20dark%20background%2C%20exciting%20and%20playful%20visual%20atmosphere&width=600&height=400&seq=card-04&orientation=landscape",
    tag: "追番",
    link: "#media",
  },
  {
    id: 5,
    title: "4K纪录片 · 视觉盛宴",
    desc: "BBC、国家地理顶级纪录片全系列，4K蓝光画质呈现。自然奇观、人文历史，震撼每一帧。",
    image: "https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20nature%20landscape%20with%20dramatic%20mountains%20and%20golden%20sunlight%2C%20documentary%20cinematography%20style%2C%20rich%20emerald%20and%20warm%20earth%20tones%2C%20majestic%20and%20serene%20visual%2C%20epic%20scale%20composition&width=600&height=400&seq=card-05&orientation=landscape",
    tag: "纪录",
    link: "#media",
  },
];

export const rankingItems = [
  { rank: 1, title: "蓝莓视频 · 暑期档热映大片合集", views: "328.6万", change: "up", trend: "↑12%", tag: "电影" },
  { rank: 2, title: "妖精视频 · 十月新番追更日历", views: "287.3万", change: "up", trend: "↑23%", tag: "番剧" },
  { rank: 3, title: "糖心视频 · 年度口碑剧集TOP50", views: "245.8万", change: "up", trend: "↑8%", tag: "剧集" },
  { rank: 4, title: "黑桃视频 · 大师经典回顾展", views: "198.2万", change: "new", trend: "NEW", tag: "经典" },
  { rank: 5, title: "4K纪录片 · 地球脉动全系列", views: "176.5万", change: "up", trend: "↑15%", tag: "纪录" },
  { rank: 6, title: "51视频 · 无广告观影体验报告", views: "154.9万", change: "up", trend: "↑6%", tag: "平台" },
];

export const features = [
  {
    id: 1,
    icon: "ri-4k-line",
    title: "蓝光4K超清画质",
    desc: "全站支持4K蓝光画质播放，智能自适应码率技术，根据网络状况自动调节，兼顾画质与流畅度。",
  },
  {
    id: 2,
    icon: "ri-shield-check-line",
    title: "全程无广告不缓冲",
    desc: "承诺全年无任何形式广告干扰，纯净观影体验。自建CDN加速网络，全国多节点覆盖，播放零缓冲。",
  },
  {
    id: 3,
    icon: "ri-smartphone-line",
    title: "全设备免费在线观看",
    desc: "PC、手机、平板全平台支持，无需下载任何APP。移动端支持手势控制、画中画播放，随时随地畅享高清。",
  },
];